export enum FilterOperator {
  Equals = 0,
  NotEquals = 1,
  GreaterThan = 2,
  GreaterThanOrEqual = 3,
  LessThan = 4,
  LessThanOrEqual = 5,
  Contains = 6,
  StartsWith = 7,
  EndsWith = 8,
  In = 9,
  AnyOf = 10,

}
